import React, { useState, useEffect, useRef, useContext } from "react";
import {
  BsFillEmojiSmileFill,
  BsFillMicFill,
  BsCameraVideoFill,
  BsPaperclip,
  BsSend,
} from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai";
import EmojiPicker from "emoji-picker-react";
import api, { API_URL, AuthContext, showAlert } from "../util/api";
import Chatmessagebox from "./chatmessagebox";
import { useNavigate } from "react-router-dom";


export default function DoctorChatBox(para) {
  const { token, User, checkkyc, admin } = useContext(AuthContext);
  const [patients, setPatients] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMorePatients, setHasMorePatients] = useState(true);

  const [selectedPatient, setSelectedPatient] = useState(null);
  const [messages, setMessages] = useState([]);
  const [msgPage, setMsgPage] = useState(1);
  const [hasMoreMessages, setHasMoreMessages] = useState(true);

  const [newMessage, setNewMessage] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showEmoji, setShowEmoji] = useState(false);
  const chatRef = useRef(null);
  const [sendOnEnter, setSendOnEnter] = useState(true); // user preference

  const [online, setonline] = useState("offline");

  const [loading, setLoading] = useState(false);


  const currentUserId = User.id;


  // Load patients list



  // Polling new messages instead of Echo
  useEffect(() => {
    if (!selectedPatient) return;


    if (admin == null) {
      const interval = setInterval(async () => {
        try {
          // API endpoint that returns ONLY new messages (see Laravel section below)
          let update_link = "";

          update_link = `/chat/check-updates/${selectedPatient}?sender_id=${currentUserId}&appointment_id=${para.appointment.id}`;


          const res = await api.get(
            update_link
          );


          setonline(res.data.online);

          if (res.data.data.length > 0) {
            setMessages((prev) => [...prev, ...res.data.data]);

            // Auto-scroll only when new messages arrive
            setTimeout(() => {
              if (chatRef.current) {
                chatRef.current.scrollTop = chatRef.current.scrollHeight;
              }
            }, 100);
          }
        } catch (error) {
          console.error("Polling error:", error);
        }
      }, 10000); // every 5 seconds

      return () => clearInterval(interval);
    }

  }, [selectedPatient, messages, currentUserId]);




  useEffect(() => {

    /* loadPatients(1); */
    loadMessages(para.id);
  }, []);

  const loadPatients = async (pageNo = 1) => {
    try {
      const res = await api.get(`/chat/users?page=${pageNo}&sender_id=${currentUserId}&appointment_id=${para.appointment.id}`);
      if (pageNo === 1) {
        setPatients(res.data.data);
      } else {
        setPatients((prev) => [...prev, ...res.data.data]);
      }
      setHasMorePatients(res.data.has_more);
    } catch (err) {
      console.error("Error loading patients:", err);
    }
  };

  // Infinite scroll for users
  const handlePatientScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 10 && hasMorePatients) {
      const nextPage = page + 1;
      setPage(nextPage);
      loadPatients(nextPage);
    }
  };

  // Load messages with pagination
  const loadMessages = async (patientId, pageNo = 1) => {


    try {
      const res = await api.get(`/chat/messages/${patientId}?page=${pageNo}&sender_id=${currentUserId}&appointment_id=${para.appointment.id}`);

      setonline(res.data.online);


      if (pageNo === 1) {
        setMessages(res.data.data.reverse());
      } else {
        setMessages((prev) => [...res.data.data.reverse(), ...prev]);
      }
      setHasMoreMessages(res.data.has_more);
      //setSelectedPatient(patients.find((p) => p.id === patientId));
      setSelectedPatient(patientId);
      setMsgPage(pageNo);
      setTimeout(() => {
        if (pageNo === 1 && chatRef.current) {
          chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }
      }, 100);
    } catch (err) {
      console.error("Error loading messages:", err);
    }
  };

  // Infinite scroll for messages (scroll up)
  const handleScrollMessages = (e) => {
    if (e.target.scrollTop === 0 && hasMoreMessages && selectedPatient) {
      const nextPage = msgPage + 1;
      setMsgPage(nextPage);
      loadMessages(selectedPatient, nextPage);
    }
  };

  // Handle file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "image/",
      "video/",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "text/plain",
    ];

    if (!allowedTypes.some((type) => file.type.startsWith(type))) {
      alert("Only images, videos, or documents are allowed.");
      return;
    }

    setAttachment(file);
    setUploadProgress(0);
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setUploadProgress(progress);
      if (progress >= 100) clearInterval(interval);
    }, 150);
  };

  // Handle emoji
  const onEmojiClick = (emojiObject) => {
    setNewMessage((prev) => prev + emojiObject.emoji);
  };

  const handleRemoveAttachment = () => {
    setAttachment(null);
    setUploadProgress(0);
  };

  // Send message
  const handleSendMessage = async () => {
    if (newMessage.trim() === "" && !attachment) return;
    if (!selectedPatient) return alert("Please select a patient first.");

    setLoading(true);

    const formData = new FormData();
    formData.append("receiver_id", selectedPatient);
    formData.append("message", newMessage);
    if (attachment) formData.append("attachment", attachment);

    try {

      let send_link = `/chat/send?sender_id=${currentUserId}&appointment_id=${para.appointment.id}`;

      if (admin != null) {

        send_link = `/chat/send?sender_id=${currentUserId}&appointment_id=${para.appointment.id}&admin=yes`;

      }
      const res = await api.post(send_link, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.status === "success") {

        setMessages((prev) => [...prev, res.data.message]);
        setNewMessage("");
        setShowEmoji(false);
        setAttachment(null);
        setUploadProgress(0);

        // Update patient last message display
        setPatients((prev) => {
          const updated = prev.map((p) =>
            p.id === selectedPatient ? { ...p, last_message: newMessage } : p
          );
          return updated.sort(
            (a, b) =>
              new Date(b.last_message_time) - new Date(a.last_message_time)
          );
        });

        setTimeout(() => {
          if (chatRef.current)
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }, 100);

      } else {
        showAlert("error", "error", res.data.message);
      }
    } catch (err) {
      console.error("Message send failed:", err);
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    container: {
      display: "flex",
      height: "90vh",
      background: "#f8f9fa",
      borderRadius: 20,
      boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
      overflow: "hidden",
      flexDirection: "row",
    },
    sidebar: {
      width: "30%",
      background: "#fff",
      borderRight: "1px solid #dee2e6",
      overflowY: "auto",
      display: "none",
    },
    chatArea: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
    },
    emojiPopup: {
      position: "absolute",
      bottom: 68,
      left: 14,
      zIndex: 1200,
      boxShadow: "0 10px 30px rgba(2,6,23,0.2)",
      borderRadius: 12,
      overflow: "hidden",
    },
  };


  const navigate = useNavigate();

  const startCall = async () => {
    const res = await api.post(
      `${API_URL}/appointments/${para.appointment.id}/start-call`
    );

    if (res.data.success === true) {

      navigate(`/video-call/${para.appointment.id}`, {
        state: res.data
      });

    } else {

      showAlert("error", "Error!", res.data.message);
    }
  };

  return (
    <div className="container-fluid" style={styles.container}>
      {/* Sidebar */}
      <div style={styles.sidebar} onScroll={handlePatientScroll}>
        <h5
          style={{
            background: "linear-gradient(135deg, #20c997, #6f42c1)",
            color: "white",
            padding: 15,
            margin: 0,
          }}
        >
          Patients
        </h5>
        {patients.map((p) => (
          <div
            key={p.id}
            onClick={() => loadMessages(p.id)}
            style={{
              padding: 12,
              cursor: "pointer",
              borderBottom: "1px solid #eee",
              background:
                selectedPatient === p.id ? "#d4edda" : "transparent",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>{p.name}</div>
            {p.unseen_count > 0 && (
              <span
                style={{
                  backgroundColor: "#dc3545",
                  color: "white",
                  borderRadius: "50%",
                  padding: "2px 6px",
                  fontSize: "12px",
                }}
              >
                {p.unseen_count}
              </span>
            )}
          </div>
        ))}
      </div>

      {/* Chat Area */}
      <div style={styles.chatArea}>

        {/* Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #20c997, #6f42c1)",
            color: "white",
            padding: "15px 20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {selectedPatient ? (
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={para.picture != null ? para.picture : `https://cdn-icons-png.flaticon.com/512/2922/2922510.png`}
                alt="patient"
                style={{
                  width: "45px",
                  height: "45px",
                  borderRadius: "50%",
                  marginRight: "10px",
                }}
              />
              <div>
                <h6 style={{ marginBottom: "2px" }}>{selectedPatient.name}</h6>
                <small>  {online}</small>
              </div>
            </div>
          ) : (
            <h6>Select a patient to chat</h6>
          )}

          <div>
            {/*   <button className="btn btn-light btn-sm mx-1" style={{ borderRadius: "50%" }}>

              <a href="http://camera.centrenut.com/"> <BsFillMicFill /></a>
            </button> */}
            {para.appointment.status === "booked" &&
              <button onClick={() => { startCall(); }} className="btn btn-light btn-sm mx-1" style={{ borderRadius: "50%" }}>
                <BsCameraVideoFill />
              </button>
            }
          </div>
        </div>

        {/* Messages */}
        <div
          ref={chatRef}
          onScroll={handleScrollMessages}
          style={{
            flexGrow: 1,
            overflowY: "auto",
            padding: "20px",
            backgroundColor: "#f8f9fa",
          }}
        >
          {messages.length === 0 && (
            <div style={{ textAlign: "center", color: "#aaa" }}>
              No messages yet.
            </div>
          )}
          {messages.map((msg, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent:
                  msg.sender_id === selectedPatient
                    ? "flex-start"
                    : "flex-end",
                marginBottom: "12px",
              }}
            >

              {msg.admin === "yes" ?


                <Chatmessagebox msg={msg} backcolor="red" textcolor="white" />

                : <>

                  {msg.sender_id === selectedPatient ?

                    <Chatmessagebox msg={msg} backcolor="#e9ecef" textcolor="black" />

                    : <Chatmessagebox msg={msg} backcolor="#20c997" textcolor="white" />}

                </>}

            </div>
          ))}
        </div>

        {/* (rest of your input box, attachments, and emoji remain same) */}

        {/* Attachment Preview */}
        {attachment && (
          <div
            style={{
              padding: "10px 20px",
              backgroundColor: "#f1f3f5",
              borderTop: "1px solid #dee2e6",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexGrow: 1,
              }}
            >
              {attachment.type.startsWith("image/") && (
                <img
                  src={URL.createObjectURL(attachment)}
                  alt="preview"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "10px",
                    objectFit: "cover",
                  }}
                />
              )}
              {attachment.type.startsWith("video/") && (
                <video
                  src={URL.createObjectURL(attachment)}
                  style={{ width: "60px", borderRadius: "10px" }}
                />
              )}
              {!attachment.type.startsWith("image/") &&
                !attachment.type.startsWith("video/") && (
                  <span>📄 {attachment.name}</span>
                )}

              {/* Upload Progress */}
              <div
                className="progress"
                style={{ flexGrow: 1, height: "6px", borderRadius: "5px" }}
              >
                <div
                  className="progress-bar progress-bar-striped progress-bar-animated"
                  role="progressbar"
                  style={{
                    width: `${uploadProgress}%`,
                    background: "#20c997",
                  }}
                ></div>
              </div>
            </div>

            <button
              onClick={handleRemoveAttachment}
              className="btn btn-danger btn-sm"
              style={{ borderRadius: "50%" }}
            >
              <AiOutlineClose />
            </button>
          </div>
        )}

        {/* Input Box */}
        {(selectedPatient && para.appointment.status === "booked") ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "15px 20px",
              borderTop: "1px solid #dee2e6",
              backgroundColor: "#fff",
            }}
          >
            <label
              htmlFor="fileUpload"
              style={{ cursor: "pointer", marginRight: "10px" }}
            >
              <BsPaperclip size={20} color="#20c997" />
            </label>
            <input
              id="fileUpload"
              type="file"
              accept="image/*,video/*,application/pdf,.doc,.docx"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <div style={{ position: "relative", marginRight: "10px" }}>
              <BsFillEmojiSmileFill
                size={22}
                onClick={() => setShowEmoji((s) => !s)}
                color="#6f42c1"
                style={{ marginRight: "10px" }}
              />
              {showEmoji && (
                <div style={styles.emojiPopup}>
                  <EmojiPicker onEmojiClick={onEmojiClick} />
                </div>
              )}
            </div>
            <div style={{ display: "flex", alignItems: "center", marginRight: "10px" }}>
              <input
                title="send on Enter"
                type="checkbox"
                id="sendOnEnter"
                checked={sendOnEnter}
                onChange={() => setSendOnEnter(!sendOnEnter)}
                style={{ marginRight: "5px" }}
              />
              <label htmlFor="sendOnEnter" style={{ fontSize: "10px", cursor: "pointer" }}>

              </label>
            </div>


            <textarea
              type="text"
              className="form-control"
              placeholder="Type a message..."
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey && sendOnEnter) {
                  e.preventDefault(); // prevent new line
                  handleSendMessage();
                }
              }}

              style={{ borderRadius: "30px", padding: "10px 20px" }}
            ></textarea>
            <button
              className="btn btn-success ms-2"

              onClick={() => { if (!loading) handleSendMessage(); }}
              disabled={loading}

              style={{
                borderRadius: "50%",
                background: "#20c997",
                border: "none",
                ...(loading ? { opacity: 0.6, cursor: "not-allowed" } : {})
              }}

            >

              {loading ? <> <span style={{ fontSize: "9px" }}> sending... </span></> : <BsSend />}
            </button>
          </div>
        ) : <></>}
      </div>
    </div>
  );
}
